'use client';

import dynamic from 'next/dynamic';
import { Container } from '@weareconceptstudio/core';

//* Styles
import NewsTemplateStyle from './style';

//* Components
const List = dynamic(() => import('./components/List'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const NewsTemplate = ({ pageData }) => {
	const { title } = pageData.content;

	return (
		<NewsTemplateStyle>
			<Container>
				<List title={title} />
			</Container>
		</NewsTemplateStyle>
	);
};

export default NewsTemplate;
